import { Pipe, PipeTransform } from "@angular/core";
import { FacilityAssignmentType, LoanFacilityHistoryData } from "./account.model";

@Pipe({
    name: "facitlityHistoryAssignementLabel",
    standalone: false
})
export class FacitlityHistoryAssignementLabelPipe implements PipeTransform {
  transform(historicalAssignment: LoanFacilityHistoryData): string {
    let label = historicalAssignment?.facilityName;

    if(historicalAssignment.assignmentType === FacilityAssignmentType.DefaultAssignment) {
        return label;
    }

    label = `${label} by ${historicalAssignment.initiator}`

    if(historicalAssignment.assignmentType == FacilityAssignmentType.Pledging) {
        label = `Pledged to ${label}`
    }

    if(historicalAssignment.assignmentType == FacilityAssignmentType.Reassignment) {
        label = `Reassigned to ${label}`
    }

    return label;
  }
}
